module.exports = __webpack_public_path__ + "img/sass-thumb-3.211b8045.png";